/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("TeamMemberFilter", ["jquery", "Behaviors"], factory);
    } else {
        root.TeamMemberFilter = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};
    var moduleInstanceId;

    function TeamMemberFilter(target) {
       
        //handle multiple instances in one page

        this.moduleInstanceId = '.fl-node-' + target.getAttribute( 'data-team-member-filter' );

        Behaviors.init(TeamMemberFilter, this, arguments);

        this.element = this.$elem[0];

        $(TeamMemberFilter.ELEMENTS.FILTER_ITEM).click(function(){


            $(TeamMemberFilter.ELEMENTS.COLUMN_WRAPPER).hide();

            if( $(this).attr('id') == 'filter-all'){
                
                $(TeamMemberFilter.ELEMENTS.FILTER_ITEM).each(function(){
                  
                    if( $(this).hasClass('active') ){
                        $(this).removeClass('active');
                    }
                });

                $(this).addClass('active');

                //show all items
                $(TeamMemberFilter.ELEMENTS.COLUMN).each(function(){

                    var that = $(this);

                    if(! $(this).hasClass('active') ){

                        if( ! $(this).hasClass('hidden-in-all-tab') ){

                            $(this).addClass('active');

                            that.css('display','block');
                            
                            // setTimeout( function(){
                            //     that.css('display','block');
                            // },200);
                        } 

                    } 
                });

            }else{
                if(! $(this).hasClass('active')){
                    //deactive other fitlers
                    $(TeamMemberFilter.ELEMENTS.FILTER_ITEM).each(function(){
                        $(this).removeClass('active');
                    });
                    //active clicked item
                    $(this).addClass('active');
    
                    //get selected filter
                    var selectedFilter = $(this).attr('id');
    
                    //hide inactive filters
                    $(TeamMemberFilter.ELEMENTS.COLUMN).each(function(){

                        var that = $(this);

                        if( $(this).data('groups').includes(selectedFilter) ){

                            $(this).addClass('active');

                            that.css('display','block');

                            // setTimeout( function(){
                            //     that.css('display','block');
                            // },200);
                            
                        }else{ 

                            $(this).removeClass('active');

                            that.css('display','none');

                            // setTimeout( function(){
                            //     that.css('display','none');
                            // },200);
                            
                        }
                    });
    
                }
            }

            $(TeamMemberFilter.ELEMENTS.COLUMN_WRAPPER).fadeIn();
           
        });
        


    }

    Behaviors.inherit(TeamMemberFilter, Behaviors.Behavior);

    TeamMemberFilter.QUERY = "[data-team-member-filter]";

    TeamMemberFilter.ELEMENTS = {
        FILTER_ITEM : '[data-team-member-filter] .filter-item',
        COLUMN_WRAPPER : '[data-team-member-filter] .team-members-wrapper',
        COLUMN : '[data-team-member-filter] .column'
    };

    
    Behaviors.register_behavior(TeamMemberFilter);

    module.TeamMemberFilter = TeamMemberFilter;

    return module;
}));
